import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "deleteActivitySuccess",
  tabindex: "-1",
  "aria-labelledby": "deleteActivitySuccess",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteActivitySuccess"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body p-0" }
const _hoisted_8 = { class: "text-center py-4 mb-4 border-bottom" }
const _hoisted_9 = { class: "d-flex justify-content-center mb-4" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  serverErrorDelete: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)(__props.serverErrorDelete ? 'SG43deleteError' : 'SG49deleteSuccess')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('SG49successDeletePersonalActivity')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})